module.exports = __webpack_public_path__ + "static/media/bitmap@3x.06fb28d3.jpg";